/**
 * persistence/clientInfo.js
 *
 * Identifies the browser that produced a save, so Firestore history can show
 * which device/tab wrote a given commit or backup.
 */

import { DEVICE_ID_KEY } from "./config";

let cachedDeviceId = null;

function _getDeviceId() {
  if (cachedDeviceId) return cachedDeviceId;
  try {
    let id = localStorage.getItem(DEVICE_ID_KEY);
    if (!id) {
      id = `d_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
      localStorage.setItem(DEVICE_ID_KEY, id);
    }
    cachedDeviceId = id;
  } catch (err) {
    // Storage blocked — fall back to a per-page-load id so writes still carry one.
    console.warn("[clientInfo] device id unavailable:", err.message);
    cachedDeviceId = `d_volatile_${Math.random().toString(36).slice(2, 10)}`;
  }
  return cachedDeviceId;
}

function _getTabId() {
  try {
    return sessionStorage.getItem("tab_id") ?? null;
  } catch {
    return null;
  }
}

/**
 * @returns {{deviceId: string, tabId: string|null, userAgent: string,
 *            platform: string, language: string, timeZone: string, screen: string}}
 */
export function getClientInfo() {
  const nav = typeof navigator !== "undefined" ? navigator : {};
  let timeZone = "";
  try {
    timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone ?? "";
  } catch {
    timeZone = "";
  }
  return {
    deviceId: _getDeviceId(),
    tabId: _getTabId(),
    userAgent: nav.userAgent ?? "",
    platform: nav.userAgentData?.platform ?? nav.platform ?? "",
    language: nav.language ?? "",
    timeZone,
    screen: typeof window !== "undefined" && window.screen
      ? `${window.screen.width}x${window.screen.height}`
      : "",
  };
}
